import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import BankTransactionCallBack from "./components/CallBack";
import AppLogo from "Assets/svg/logo/logo.svg";
import AppLogoText from "Assets/svg/logo/logo-text.svg";
import MobilePayment from "Services/http/endpoints/payment/MobilePayment";
import BankTransactionWrongLink from "./components/WrongLink";
import BankTransactionLoading from "./components/Loading";
import BankTransactionRedirect from "./components/Redirect";
import { useCookies } from "react-cookie";

export default function BankTransactionIndex(props) {
  const option = { path: "/", maxAge: 600 };
  const [paymentType, setpaymentType] = useState(-1);
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(false);
  const [cookies, setCookie] = useCookies(["gKey", "uKey", "oId"]);

  useEffect(() => {
    const mode = window.location.pathname;
    (async () => {
      if (mode.includes("callback")) {
        await checkCallBack();
      } else {
        await getValidationLink();
      }
    })();
  }, []);

  const getValidationLink = async () => {
    setLoading(true);
    try {
      const queryParameters = new URLSearchParams(window.location.search);
      const params = queryParameters.has("params")
        ? atob(queryParameters.get("params"))
        : null;
      if (params) {
        let _params = JSON.parse(params);
        const Link = _params.Link ? _params?.Link : null;
        const KeyGroup = _params.KeyGroup ? _params.KeyGroup : null;
        const KeyUser = _params.KeyUser ? _params?.KeyUser : null;
        const Order = _params.OrderId ? _params?.OrderId : null;
        const Token = _params.token ? _params?.token : null;
        if (KeyGroup && KeyUser && Order && Link && Token) {
          const response = await MobilePayment.GetActiveAccounting({
            KeyGroup,
            KeyUser,
          });
          if (response && response.data.Value) {
            setCookie("gKey", KeyGroup, option);
            setCookie("uKey", KeyUser, option);
            setCookie("oId", Order, option);
            setCookie("utk", Token, option);
            setpaymentType(1);
            window.open(Link, "_self");
          } else {
            setpaymentType(3);
          }
        } else {
          setpaymentType(3);
        }
      } else {
        setpaymentType(3);
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
    setLoading(false);
  };

  const checkCallBack = async () => {
    setLoading(true);
    try {
      const KeyGroup = cookies.gKey ? cookies.gKey : null;
      const KeyUser = cookies.uKey ? cookies.uKey : null;
      const OrderId = cookies.oId ? cookies.oId : null;
      const Token = cookies.utk ? cookies.utk : null;
      if (KeyGroup && KeyUser && OrderId && Token) {
        const response = await MobilePayment.GetPaymentInfo(
          { KeyGroup, KeyUser, OrderId },
          Token
        );
        if (response) {
          const data = response.data.Value;
          if (data.NotFound) {
            setpaymentType(3);
          } else if (data.Transfer && data.RetrivalRefNo) {
            setStatus(true);
            setpaymentType(2);
          } else {
            setStatus(false);
            setpaymentType(2);
          }
        } else {
          setpaymentType(3);
        }
      } else {
        setpaymentType(3);
      }
    } catch (err) {
      console.error("[catch error]", err);
    }
    setLoading(false);
  };

  return (
    <div className="w-100 d-flex flex-column justify-content-start align-items-center pt-5">
      <div className="logo mb-4">
        <img src={AppLogo} alt="session-logo" height="50" className="ml-1" />
        <img src={AppLogoText} alt="session-logo" height="55" />
      </div>
      {loading ? (
        <BankTransactionLoading />
      ) : (
        <>
          {paymentType === 1 && <BankTransactionRedirect />}
          {paymentType === 2 && <BankTransactionCallBack status={status} />}
          {paymentType === 3 && <BankTransactionWrongLink />}
        </>
      )}
    </div>
  );
}
